import { useState, useRef } from "react";

// components
import VideoProgress from "./VideoProgress";

// assets
import play from "bodycodi/cmap/app/svg/community_video_play_triangle.svg";

// props
import { MediaProps } from "./types";

const ThumbnailVideo = ({ file }: MediaProps) => {
  const ref = useRef<any>(null);
  const [duration, setDuration] = useState<any>("");

  const handleLoadedMetadata = () => {
    const video: any = ref.current;
    if (!video) return;

    var s = video.duration;

    var m: any = Math.floor(s / 60);
    m = m >= 10 ? m : "0" + m;
    s = Math.floor(s % 60);
    s = s >= 10 ? s : "0" + s;
    setDuration(m + ":" + s);
  };

  return file.videoConvertFlag === "C" ? (
    <div className="thumbnail-container">
      <div className="video-wrap">
        <video poster={file.thumbNail} ref={ref} onLoadedMetadata={handleLoadedMetadata}>
          <source src={file.fileUrl} />
        </video>
        <div className="dark-overlay">
          <div className="play-button">
            <img src={play} />
          </div>
        </div>
      </div>
      {!!duration.length && <div className="duration">{duration}</div>}
    </div>
  ) : (
    <VideoProgress />
  );
};

export default ThumbnailVideo;
